import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ProductBatch} from "../../../model/product-batch.type";

@Component({
  selector: 'vb-product-batches-listing',
  templateUrl: './product-batches-listing.component.html',
  styleUrls: ['./product-batches-listing.component.css']
})
export class ProductBatchesListingComponent implements OnInit {

  @Input()
  productBatches: ProductBatch[];

  @Output()
  deleteProductBatchClicked: EventEmitter<string> = new EventEmitter<string>();

  constructor() {
  }

  ngOnInit() {
  }

  onDeleteProductBatchClicked(productBatchCuid: string) {
    this.deleteProductBatchClicked.emit(productBatchCuid);
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/stock/components/product-batches-listing/product-batches-listing.component.ts